import { Route, Navigate } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { PersonalRoutes } from 'pages/settings/pages/personal/route/type'
import { AccountRouter } from 'pages/settings/pages/personal/pages/account'
import { AuthorizedAppsRouter } from 'pages/settings/pages/personal/pages/authorizedApps'

export const PersonalRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route path={`/${PersonalRoutes.settings}/*`} element={<AccountRouter />} />
      <Route path={`/${PersonalRoutes.authorizedApps}`} element={<AuthorizedAppsRouter />} />
      <Route
        index
        element={<Navigate to={`${PersonalRoutes.settings}/${PersonalRoutes.profile}`} replace />}
      />
    </RoutesWithNotFound>
  )
}
